<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WTSwYu/tc-custom/9781960436375.jpg?1731411198664" alt="This image is the cover for the book 40 días con la Palabra y el Espíritu"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">40 días con la Palabra y el Espíritu
      </h1>
      <p class="bookDescription body article font2">
        <p>Prepárate para este gran avivamiento espiritual A medida que nuestro mundo se vuelve más incierto, muchos anticipan el surgimiento de un mover de Dios sin precedentes. ¿Quiénes impulsarán ese movimiento? ¿Aquellos que se han enfocado en el Espíritu? ¿O los que se han centrado en la Palabra de Dios? Este devocional está diseñado con el fin de preparar tu corazón para el glorioso despertar de los últimos días y liberarte de viejos paradigmas que impiden el mover de Dios. Basándose en la enseñanza de su histórico discurso de 1992 en el Centro de Conferencias de Wembley, en Londres, R. T. Kendall te lleva en un trayecto de cuarenta días para preparar tu corazón, para lo que él describe proféticamente como un avivamiento venidero. Un avivamiento que… Sea inspirado por la Palabra de Dios. Sea dirigido por el Espíritu Santo. No se base en sentimientos ni emociones. Vive el poder de la Palabra y la presencia del Espíritu Santo “Es mi oración que mientras lee este devocional —afirma R. T. Kendall— comprenda el costo del divorcio silencioso que ha ocurrido y que empiece a anticipar el nuevo mover de Dios que volverá a impartir con su Palabra y su Espíritu. Atesoremos la infalible Palabra de Dios y rindámonos por completo a la obra de su Espíritu Santo”.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R. T. Kendall
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6fc24c78